import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import Button from '../../../../Button'
import { Divider } from '../../../../Divider'
import { FileMultiValue } from '../../../../File'
import { toUserSelectItem } from '../../../../User'
import { useDocFlowContext } from '../../../DocFlow.hooks'
import {
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
  DocFlowAddRecipientFields,
} from '../../../DocFlowAddRecipientFields'
import {
  QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_SKIP_BTN,
  QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_SUBMIT_BTN,
} from '../DocFlowMappingRecipientModal.constants'
import { getDocFlowMappingRecipientModalSuggestions } from '../DocFlowMappingRecipientModal.utils'
import { DocFlowMappingRecipientModalSuggestions } from '../DocFlowMappingRecipientModalSuggestions'

import * as styles from './DocFlowMappingRecipientModalPanel.module.css'

function DocFlowMappingRecipientModalPanel({
  activeFile,
  hasNext,
  isLoading,
  item,
  onSkip,
}) {
  const { t } = useTranslation()

  const { isSubmitting, setFieldValue, values } = useFormikContext()

  const { documentId } = useDocFlowContext()

  const recipient = values[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]

  const suggestions = getDocFlowMappingRecipientModalSuggestions({
    item,
    values,
  })

  function handleAddSuggestion(suggestion) {
    setFieldValue(
      DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
      toUserSelectItem(suggestion)
    )
  }

  return (
    <div className={styles.DocFlowMappingRecipientModalPanel}>
      <div className={styles.content}>
        <FileMultiValue
          className={styles.file}
          item={activeFile}
          textClassName={styles.fileName}
        />
        <Divider className={styles.divider} />
        <DocFlowAddRecipientFields edit documentId={documentId} />
        {suggestions.length > 0 ? (
          <DocFlowMappingRecipientModalSuggestions
            disabled={isLoading}
            items={suggestions}
            onAdd={handleAddSuggestion}
          />
        ) : null}
      </div>
      <div className={styles.footer}>
        <Button.Contained
          disabled={!recipient || isLoading}
          isLoading={isSubmitting}
          qaName={QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_SUBMIT_BTN}
          text={t(
            hasNext
              ? 'DocFlow.MappingRecipientModalSaveAndNextBtnKey'
              : 'Modal.SaveBtnKey'
          )}
          tooltip={
            recipient
              ? null
              : t('DocFlow.MappingRecipientModalSaveDisabledTooltipKey')
          }
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          type='submit'
        />
        {hasNext ? (
          <Button.Outlined
            disabled={isLoading}
            qaName={QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_SKIP_BTN}
            text={t('DocFlow.MappingRecipientModalSkipBtnKey')}
            tooltip={t('DocFlow.MappingRecipientModalSkipBtnTooltipKey')}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={onSkip}
          />
        ) : null}
      </div>
    </div>
  )
}

export default DocFlowMappingRecipientModalPanel
